import { render, staticRenderFns } from "./infancy.vue?vue&type=template&id=07126a58&scoped=true"
import script from "./infancy.vue?vue&type=script&lang=js"
export * from "./infancy.vue?vue&type=script&lang=js"
import style0 from "./infancy.vue?vue&type=style&index=0&id=07126a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07126a58",
  null
  
)

export default component.exports